var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('loading',{staticStyle:{"position":"relative"},attrs:{"active":_vm.loading,"can-cancel":false,"is-full-page":false,"color":"#259ED9","opacity":0,"default":"spinner"},on:{"update:active":function($event){_vm.loading=$event}}},[_c('spinner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }